<style>
.el-table__body tr.current-row>td {
    background-color: #69a8ea !important;
    color: rgb(236, 17, 17);
}

.rt-lookup-dialog .el-dialog {
    min-width: 700px;
}

.rt-lookup-dialog .el-form-item .el-form-item__label {
    width: 120px;
}

.rt-lookup-dialog .el-form-item .el-form-item__label:before {
    display: none;
}

.rt-lookup-dialog .el-form-item .el-form-item__content {
    margin-left: 120px !important;
}

.rt-lookup-dialog .el-table {
    margin-top: 15px;
}

.rt-lookup-dialog .el-dialog__body {
    padding-bottom: 15px;
}
</style>



<template>
    <!-- <div class="assign-dialog">
    <rt-grid
      class="assign-dialog"
      ref="grid"
      quicksearch-placeholder="请输入销售员名字"
      :totalRecord="totalRecordCount"
      @page-change="handlePageChange"
      @quick-search="handleSearch"
      :views="['']"
    >
                                      <el-table
                                        highlight-current-row
                                        style="width: 100%; height: 75%; overflow: auto"
                                        @current-change="handleCurrentChange"
                                        v-bind:data="tableData"
                                        tooltip-effect="dark"
                                        v-loading="loading"
                                        :header-cell-style="{ background: '#F0F3F7' }"
                                        :row-class-name="tabRowClassName"
                                        @selection-change="handleSelectionChange"
                                      >
                                        <el-table-column type="selection" width="80%"></el-table-column>
                                        <el-table-column label="渠道商代理商" prop="new_name"></el-table-column>

                                        <template slot="empty">
                                          <img
                                            style="margin-top: 50px"
                                            src="../../assets/imgs/home/no-order.png"
                                            alt
                                          />
                                          <p class="nodata-prompt">Sorry！未找到相应结果哦~换个关键词试试！</p>
                                        </template>
                                    </el-table>
    </rt-grid>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel('assignVisible')">取消</el-button>
        <el-button type="primary" @click="callback" :loading="saving"
                                        >确定</el-button
                                      >
                                    </div>
                                  </div> -->
    <el-dialog append-to-body class="rtportal rt-lookup-dialog" :close-on-click-modal="false" :title="'共享'"
        :visible.sync="dialogVisible">
        <el-row style="display: flex; align-items: center">
            <!-- <el-col :span="4">{{ $tx("搜索", "lookup.search") }}</el-col> -->
            <el-col :span="4">{{ $t("lookup.search") }}</el-col>

            <el-col :span="20">
            <el-input v-model="filterValue" @keyup.enter.native="handleSearch"
                :placeholder="$t('lookup.searchRecords')">
                    <el-button type="text" slot="append" icon="el-icon-search" style="margin-top: -12px"
                        @click="handleSearch"></el-button>
                </el-input>
        </el-col>
    </el-row>
        <el-table ref="lookupTable" style="width: 100%" height="430" :row-class-name="tabRowClassName" highlight-current-row
            :header-cell-style="{ background: '#F0F3F7' }" v-bind:data="tableData" border stripe
            @current-change="handleCurrentChange" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="80%"></el-table-column>
            <el-table-column label="渠道商代理商" prop="new_name"></el-table-column>

            <template slot="empty">
                <img style="margin-top: 50px" src="@/assets/imgs/home/no-order.png" alt />
                <!-- <p class="nodata-prompt">
                                          {{
                                            $tx("Sorry！未找到相应结果哦~换个关键词试试！", "common.nofindData")
                                          }}
                                        </p> -->
                <p class="nodata-prompt">
                    {{ $t("all.notfound") }}
                </p>
            </template>
        </el-table>
        <div slot="footer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleIndexChange" :current-page="pageIndex"
                :page-size="pageSize" :page-sizes="pageSizes" :layout="layout" :total="totalRecordCount"
                style="margin-bottom: 10px; text-align: center"></el-pagination>
            <span class="dialog-footer">
                <!-- <el-button @click="handleReset">{{
                                          $tx("移除值", "lookup.remove")
                                        }}</el-button> -->
                <el-button @click="handleReset">{{ $t("lookup.remove") }}</el-button>

                <!-- <el-button type="primary" @click="handleConfirm">{{
                                          $tx("确 定", "filter.confirm")
                                        }}</el-button> -->
                <el-button type="primary" @click="callback">{{
                    $t("filter.confirm")
                }}</el-button>
            </span>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "rtShareEntity",
    data() {
        return {
            dialogVisible: false,
            loading: false,

            filterValue: "",
            pageIndex: 1,
            pageSize: 20,
            layout: "total, sizes, prev, pager, next",
            pageSizes: [10, 20, 30, 40, 50],
            totalRecordCount: 0,

            tableData: [],
            currentRow: null,
            ids: [],
        };
    },
    props: {
        entityName: {
            type: String,
            required: true,
        },
        entityId: {
            type: String,
            required: true,
        },
    },
    mounted: function () {
        this.getAccountStaff();
    },
    methods: {
        handleIndexChange(pageIndex) {
            this.pageIndex = pageIndex;

            this.getAccountStaff();
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getAccountStaff();
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
        //在methods总通过方法计算返回对应class样式
        tabRowClassName({ row, rowIndex }) {
            let index = rowIndex + 1;
            if (index % 2 == 0) {
                return "even-row";
            }
        },
        handleReset() {
            this.$emit("data-selected", {
                id: null,
                logicalName: this.logicalName,
                name: null,
            });

            this.dialogVisible = false;
        },
        show() {
            this.dialogVisible = true;
            this.pageIndex = 1;
            this.getAccountStaff();
        },
        handleSearch() {
            this.getAccountStaff();
        },
        async getAccountStaff() {
            // let url = "api/ChannelReport/GetLookupAccountstaff";
            let params = {
                entityName: "new_accountstaff",
                page: this.pageIndex,
                count: this.pageSize,
                select: "new_name,new_accountstaffid",
                orderby: "",
                condition: "",
                filter: "",
                filterValue: this.filterValue || "",
            };
            let url = `api/ChannelReport/GetLookupAccountstaff?entityName="new_accountstaff"&page=${this.pageIndex}&count=${this.pageSize}&select="new_name,new_accountstaffid"&orderby=&condition=&filter=&filterValue=${this.filterValue || ""}`

            rt.get(url, params)
                .then((res) => {
                    this.tableData = res.Data;
                    this.totalRecordCount = res.TotalRecordCount;

                    // this.$nextTick(() => {
                    //   this.$refs.lookupTable.doLayout();
                    // });

                    this.loading = false;
                })
                .catch((error) => {
                    rt.showErrorToast(error);

                    this.loading = false;
                });
        },
        handlePageChange() {
            this.getAccountStaff();
        },
        handleCurrentChange(val) {
            this.curSelect = val;
        },
        handleSelectionChange(val) {
            // 列表 check 选择行id
            this.ids = val.map((item) => {
                return item.new_accountstaffid;
            });
        },
        async callback() {
            if (!this.ids || !this.ids.length) {
                rt.showErrorToast("请选择要共享的数据");
                return;
            }
            try {
                this.$confirm(this.$t("是否要共享"), {
                    confirmButtonClass: "ConfirmButtonClass",
                    cancelButtonClass: "CancelButtonClass",
                    type: "warning",
                })
                    .then(() => {
                        let params = {
                            entityName: this.entityName,
                            entityId: this.entityId,
                            accountstaffId: this.ids,
                        };
                        rt.post("api/Opportunity/Share", params)
                            .then((res) => {
                                rt.showSuccessToast("共享成功");
                                this.dialogVisible = false;
                            })
                            .catch((err) => {
                                rt.showErrorToast(err);
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: this.$t("已取消共享"),
                        });
                    });
            } catch (msg) {
                this.saving = false;
                rt.showErrorToast(msg);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// rtShareEntity.vue?b548276c